module.exports = __webpack_public_path__ + "img/gallary01.e532a85b.png";